// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f7951ef8","150":"89b5a2a9","168":"5beb6630","387":"ff8ea0ec","453":"ad417c0f","615":"e795dbeb","854":"e7b831ec","983":"6275ecf7"}[chunkId] + ".chunk.js";
};